import React, { useEffect, useState } from "react";
import { Map, Marker, Overlay } from "pigeon-maps";
import { rpcClient } from "transport-layer/src";
import { Button, Card, CardMedia, CardActions } from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import List from "@mui/material/List";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/LinkOutlined";
import { orderBy } from "lodash";
import  {Link } from 'react-admin';

const Tooltip = (props) => {
  const { title, body } = props;

  return (
    <div style={{padding: '1em', backgroundColor: 'white'}}>
      <Typography component="p">{title}</Typography>
      <Typography component="p">{body}</Typography>
    </div>
  );
};

const StoreMapComponent = (props) => {

  const value = props.existingMatchID;

  const {
    focusStoreMarker,
    storeSearchEndpointID,
    storeSearchEndpoint,
    fromStoreID,
    width,
    height,
    onChange,
    enableMatching,
    resourceLocation
  } = props;

  const defaultZoom = 12;

  const [focusedMarker, setFocusedMarker] = useState();
  const [possibleMatchMarkers, setPossibleMatchMarkers] = useState([]);
  const [center, setCenter] = useState([
    focusStoreMarker[0],
    focusStoreMarker[1],
  ]);
  const [zoom, setZoom] = useState(defaultZoom);

  const getMarkerFromAnchor = (anchor) => {
    
    return (anchor) && [...possibleMatchMarkers, focusStoreMarker].filter(
      (_marker) => _marker.lat === anchor[0] && _marker.lon === anchor[1]
    )[0]
    };
  const getMarkerElementFromAnchor = (anchor) =>
    document.querySelector("#possible_match-" + getMarkerFromAnchor(anchor)?.id);

  const onMarkerOver = ({ event, anchor, payload }) => {
    
    setFocusedMarker(getMarkerFromAnchor(anchor));
    
    if (getMarkerElementFromAnchor(anchor)) {
      getMarkerElementFromAnchor(anchor).style.backgroundColor = "lightgrey";
    }
    
  };

  const onMarkerOut = ({ event, anchor, payload }) => {
    setFocusedMarker(null);
    if (getMarkerElementFromAnchor(anchor)) {
      getMarkerElementFromAnchor(anchor).style.backgroundColor = "white";
    }

    
  };

  const mapTilerKey = "CIL3ZeVquDoIMZv0ZHyC";
  const mapTilerProvider = (x, y, z, dpr) =>
    `https://api.maptiler.com/maps/streets/256/${z}/${x}/${y}${
      dpr >= 2 ? "@2x" : ""
    }.png?key=${mapTilerKey}`;

  // Load data on init
  useEffect(() => {
    if (fromStoreID) {
      let options = {};
      options.body = JSON.stringify({
        [storeSearchEndpointID]: fromStoreID,
      });

      // Fetch possible_match matches -> possibleMatchMarkers
      rpcClient(storeSearchEndpoint, options)
        .then((e) => e.json)
        .then((e) => {
          setCenter([focusStoreMarker[0], focusStoreMarker[1]]);
          setPossibleMatchMarkers(e[0].data || []);
        });
    }
  }, [
    focusStoreMarker,
    fromStoreID,
    storeSearchEndpoint,
    storeSearchEndpointID,
  ]);

  return (
    <Card>
      <Typography variant="h6">
        {props.title || "Possible Matches"}
      </Typography>
      <CardMedia>
        <div>
          <Map
            provider={mapTilerProvider}
            dprs={[1, 2]}
            center={center}
            zoom={zoom}
            width={width}
            height={height}
            onBoundsChanged={({ center, zoom, bounds, initial }) => {
              setCenter(center);
              setZoom(zoom);
            }}
          >
            {possibleMatchMarkers?.map((marker, i) => {
              return (
                <Marker
                  key={i}
                  id={`marker-possible_match-${marker.id}`}
                  anchor={[marker.lat, marker.lon]}
                  payload={1}
                  onMouseOver={onMarkerOver}
                  onMouseOut={onMarkerOut}
                  hover={focusedMarker === marker}
                  color={value && value.includes(marker.id) ? props.matchedColor: props.possibleMatchMarkerColor}
                />
              );
            })}

            <Marker
              anchor={focusStoreMarker}
              payload={1}
              onMouseOver={() => {
                
                setFocusedMarker(focusStoreMarker)
              }}
              onMouseOut={() => setFocusedMarker(null)}
              hover={focusedMarker === focusStoreMarker}
              color={props.focusMarkerColor || "red"}
            />

            {focusedMarker ? (
              <Overlay anchor={focusedMarker} offset={[120, 79]}>
                <Tooltip
                  title={focusedMarker.store_name}
                  body={[focusedMarker.lat, focusedMarker.lon]}
                />
              </Overlay>
            ) : null}
          </Map>
          <Button
            variant="outlined"
            startIcon={<MyLocationIcon />}
            onClick={() => {
              setCenter([focusStoreMarker[0], focusStoreMarker[1]]);
              setZoom(defaultZoom + 4);
            }}
            aria-label="recenter"
          >
            Recenter
          </Button>
        </div>
      </CardMedia>

      <CardActions>
        <List
          id="possible_match-list"
          style={{ maxHeight: 400, overflowY: "auto", width: "100%" }}
        >
          {orderBy(possibleMatchMarkers.map(x => ({...x, name_similar: x['name_similar']})), ["name_similar", "distance"], ['desc', 'asc']).map((possible_match, i) => (
            <ListItem
              key={i}
              id={"possible_match-" + possible_match.id}
              alignItems="flex-start"
              style={{
                backgroundColor:
                  focusedMarker &&
                  focusedMarker.id &&
                  focusedMarker.id === possible_match.id &&
                  "lightgrey",
                borderLeft:
                  focusStoreMarker &&
                  value.includes(possible_match.id) &&
                  "4px solid orange",
              }}
              onMouseEnter={(e) => onMarkerOver({anchor: [possible_match.lat, possible_match.lon]})}
              onMouseLeave={(e) => onMarkerOut({anchor: null})}
            >
              <ListItemText
                primary={<Link to={`/${resourceLocation}/${possible_match.id}`} style={{color:'grey', textSize:'2em'}}>{possible_match.store_name}</Link>}
                secondary={
                  <span>
                    
                    {possible_match.address}
                    <br />
                    {`${possible_match.city}, ${possible_match.state} ${possible_match.address.split(' ').pop()}`}
                    <br />
                    <i>Est. Distance: {Math.round(possible_match.distance,0)} ft / Name Similarity: {possible_match.name_similar}</i>
                    <br/>
                    {possible_match.id}
                  </span>
                }
              />
              {enableMatching  && (
                <ListItemSecondaryAction>
                  {value.includes(possible_match.id) ? (
                    <IconButton
                      onClick={() => {
                        possible_match.id = null;
                        onChange(possible_match);
                      }}
                      aria-label="unmatch-possible_match-store"
                      edge="end"
                      size="large">
                      <LinkOffIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => {
                        onChange(possible_match);
                      }}
                      aria-label="match-possible_match-store"
                      edge="end"
                      size="large">
                      <LinkIcon />
                    </IconButton>
                  )}
                </ListItemSecondaryAction>
              )}
              
            </ListItem>
          ))}
        </List>
      </CardActions>
    </Card>
  );
};

export default StoreMapComponent;
